<template>
    <div class="search">
        <label class="label-search" for="search-distribuidor">{{ label_text }}</label>
        <b-form-input id="search-distribuidor" class="radius-theme" placeholder="Digite aqui código do distribuidor" autocomplete="off"
            :disabled="disabled" type="number" v-model="search" @keyup="fetchdistribuidores" @blur="visibleResult = false"
            @focus="visibleResult = true"></b-form-input>
        <transition name="fade">
            <div class="search-result default-card" v-show="visibleResult">
                <div class="result-list">
                    <b-row v-for="distribuidor in distribuidores" :key="distribuidor.id"
                        @click="selecteddistribuidor(distribuidor)">
                        <b-col md="8" class="bressay-bold-italic distribuidor-name">
                            ({{ distribuidor.codigo }}) {{ capitalize(distribuidor.nome) }}
                        </b-col>
                    </b-row>
                </div>

                <b-spinner medium v-if="searching"></b-spinner>

                <p class="text-center" v-else-if="distribuidores.length == 0">Nenhum distribuidor encontrado</p>
            </div>
        </transition>
    </div>
</template>
  
<script>
export default {
    props: {
        value: {
            type: Object
        },
        disabled: {
            type: Boolean,
            default: () => {
                return false;
            }
        },
        hasCode: {
            type: Number,
            default: () => {
                return null;
            }
        },
        actives: {
            type: Boolean,
            default: () => {
                return false;
            }
        },
        label_text: {
            type: String,
            default: () => {
                return 'Código do distribuidor:'
            }
        },
        free: {
            type: Boolean,
            default: () => {
                return false;
            }
        }
    },
    data: () => {
        return {
            distribuidores: [],
            search: "",
            searching: false,
            distribuidoreselected: null,
            visibleResult: false
        };
    },
    watch: {
        value(newValue) {
            if (newValue == null) {
                return;
            }
            this.selected(newValue);
        }
    },
    methods: {
        fetchdistribuidores() {
            this.distribuidores = [];
            if (this.search.length < 4) {
                return;
            } else if (this.value) {
                if (this.value.name == this.search) {
                    return;
                }
                this.$emit("input", null);
                this.$emit("change", null);
            }
            const vm = this;
            vm.searching = true;
            axios
                .get('/adm/distribuidor/buscar/' + vm.search)
                .then((response) => {
                    //console.log(response);
                    vm.distribuidores = response.data;
                    vm.searching = false;
                })
                .catch((erro) => {
                    console.log('erro ao buscar distribuidor', erro)
                })
        },
        selecteddistribuidor(distribuidor) {            
            this.$emit("input", distribuidor);
            this.$emit("change", distribuidor);
        },
        selected(distribuidor) {           
            this.search = "(" + distribuidor.codigo + ") " + this.capitalize(distribuidor.nome);
            // this.$emit("input", distribuidor);
            // this.$emit("change", distribuidor);
        },
        clear() {
            this.search = "";
            this.distribuidores = [];
        },
        capitalize(string) {
            return string.toLowerCase().replace(/(?:^|\s)\S/g, function (a) { return a.toUpperCase(); });
        }
    }
};
</script>
  
<style lang="scss" scoped>
.radius-theme {}

.label-search {
    text-align: left !important;
    display: block;
    margin: 0px;
}

.search {
   
}

.search-result {
    background: white;
    margin-top: 3px;
    z-index: 9;
    position: absolute;
    width: 94%;

    .result-list {
        padding: 10px 0px;

        .row {
            margin: 5px 0px;
            cursor: pointer;

            .distribuidor-name {
                font-size: 0.8em;
            }

            .distribuidor-price {
                letter-spacing: 0.45px;
                font-size: 0.8em;
            }
        }

        .row:not(:last-child) {
            border-bottom: 1px solid #979797;
        }
    }
}

.fade-enter-active,
.fade-leave-active {
    transition: all 0.3s ease;
}

.fade-enter,
.fade-leave-to

/* .fade-leave-active below version 2.1.8 */
    {
    transform: translateY(-10px);
}
</style>
  


// WEBPACK FOOTER //
// resources/assets/js/components/util/BuscaDistribuidor.vue